/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import querystring from "querystring";
import styled, { css } from "styled-components";

import Gettext, { mapStateToGettext } from "../../common/Gettext";
import { mapDispatchToFetch } from "../../common/fetch";
import { getSub0 } from "../../Subzero";
import _BtnFormSubmit from "../BtnFormSubmit";
import ErrorMessage from "../ErrorMessage";
import CountrySelect from "../CountrySelect";
import validators from "../validators";
import Container from "../StyledComponents/Container";
import Input from "../Input";
import { Link } from "../../common/Link";
import Sprite from "../../../images/logged-in-sprite.png";
import FeatureFlags from "../../../FeatureFlags";
import { FieldContainer } from "../../ReVerification/style";
import { InfoIcon } from "../../ReVerification/Icons";
import PhoneInput, {
  PhoneInputHint,
  ripOffLeadingZero,
} from "../../ReVerification/Phone/PhoneInput";
import { getPhoneExample } from "./RegisterMain";
import { gaReducer } from "../../GA";

const IS_IRON_OR_EZ =
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" ||
  process.env.REACT_APP_DEPLOY_TARGET === "eztrader";

const RegisterContainer = styled(Container)`
  padding-top: 4px;
`;

const InputContainer = styled.div`
  padding-top: 4px;
  padding-bottom: 12px;
  position: relative;

  @media (max-width: 959px) {
    padding-bottom: 8px;
  }
`;

const CheckContainer = styled.div`
  padding: 8px 0;
`;

const Checkbox = styled.input`
  display: none;
`;

const CheckboxLabel = styled.label`
  position: relative;
  display: block;
  padding: 0 0 0 31px !important;
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 1.2;
  text-align: left;
  color: ${IS_IRON_OR_EZ ? "#fff !important" : "#8d8d8d !important"};
  user-select: none;

  :before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 19px;
    height: 19px;
    border: 1px solid #cfcfcf;
    border-radius: 3px;
    color: #252525;
    background: none;
    background-color: #f6f6f6;
    box-shadow: inset 0 2px 0 0 #e3e3e3;
    cursor: pointer;
  }

  :after {
    ${(props) =>
      props.checked &&
      css`
        content: "";
        position: absolute;
        top: 50%;
        left: 5px;
        transform: rotate(45deg);
        width: 8px;
        height: 12px;
        margin-top: -8px;
        border-right: 3px solid #56496e;
        border-bottom: 3px solid #56496e;
        cursor: pointer;
      `};
  }
`;

const TermsLink = styled(Link)`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px !important"};
  line-height: 1.2 !important;
  text-decoration: none !important;
  color: #feac00 !important;
  transition: all 0.2s ease !important;

  :hover,
  :active,
  :focus {
    color: #ffc54c !important;
  }
`;

const SubmitContainer = styled.div`
  position: relative;
  max-height: 56px;
  margin-bottom: 15px;
  padding: 4px 0;
  text-align: center;

  @media (min-width: 375px) {
    vertical-align: middle;

    :after {
      content: "";
      display: inline-block;
      width: 100%;
    }
  }

  @media (max-width: 374px) {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    align-content: space-between;
    justify-content: space-between;
  }
`;

const BtnFormSubmit = styled(_BtnFormSubmit)`
  ${(props) =>
    props.isIntlProject &&
    css`
      @media (max-width: 374px) {
        margin-bottom: 0;
      }
    `};
`;

const FormText = styled.p`
  direction: ${({ theme }) => theme.direction};
  padding: 20px 20px 9px 20px;
  margin: 0;
  font-size: 21px;
  font-weight: 300;
  line-height: 1.2;
  color: #fff;

  @media (max-width: 360px) {
    font-size: 20px;
  }
`;

const LogoutLink = styled(Link)`
  position: relative;
  padding-left: 30px;
  font: 14px/26px Roboto, Arial, sans-serif;
  text-decoration: none;
  color: #feac00;
  transition: all 0.2s ease;

  @media (min-width: 375px) {
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -13px;
  }

  @media (max-width: 374px) {
    flex-grow: 0;
    flex-shrink: 0;
    align-self: center;
  }

  :before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 26px;
    height: 26px;
    background: url(${Sprite}) no-repeat;
    opacity: 0.5;
    transition: all 0.3s ease;
    background-position: left -75px;
  }

  :hover {
    color: #ffc54c;
  }

  :hover:before {
    opacity: 1;
  }
`;

const PhoneFieldContainer = styled(FieldContainer)`
  position: relative;
  width: 100%;

  @media (max-width: 959px) {
    display: flex;
  }
`;

const PhoneContainer = styled(InputContainer)`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin: 4px 0;
`;

const PhoneInfo = styled.div`
  position: absolute;
  bottom: 100%;
  left: 0;
  width: 100%;
  margin-bottom: 8px;
  padding: 27px 20px 20px 30px;
  background: #ebebeb;
  border-radius: 4px;

  :after {
    top: 100%;
    left: 18px;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    border-color: rgba(235, 235, 235, 0);
    border-top-color: #ebebeb;
    border-width: 8px;
    margin-left: -8px;
  }
`;

const IconContainer = styled.div`
  position: absolute;
  width: 16px;
  min-width: 16px;
  margin-right: 7px;
  top: 10px;
  left: 9px;
`;

const InfoText = styled.div`
  font-size: ${({ theme }) =>
    theme.locale === "ar" ? theme.minFontSize : "12px"};
  line-height: 14px;
  color: #343434;
  text-align: left;
`;

const CloseInfo = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 11px;
  height: 11px;
  cursor: pointer;
`;

const PhoneInputContainer = styled.div`
  @media (max-width: 767px) {
    :first-of-type {
      margin-bottom: 4px;
    }
  }

  @media (min-width: 768px) {
    flex: 1;
    flex-basis: 50%;
    max-width: 220px;
  }
`;

type Country = *;

type Props = {
  email: string,
  tel: string,
  agree: boolean,
  onInputChange: EventHandler,
  onLeave: (string) => void,
  countryList: Array<Country>,
  country: Country,
};

type State = {
  pending: "host" | null,
  submitTimeError: string | React.Node | null,
  responseTimeError: string | null,
  showPhoneInfo: boolean,
};

class SocialRegister extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    let fields = [];

    if (this.props.profile && !this.props.profile.email) {
      fields.push("email");
    }

    if (IS_IRON_OR_EZ && (this.props.profile && !this.props.profile.currency)) {
      fields.push("currency");
    }

    if (this.props.profile && !this.props.profile.phone) {
      fields.push("phone");
    }

    this.state = {
      country: null,
      pending: null,
      emailError: null,
      countryError: null,
      telError: null,
      agreeError: null,
      submitTimeError: null,
      responseTimeError: this.props.socialError,
      showPhoneInfo: false,
      fields: fields,
    };
  }

  register = async (event: SyntheticEvent<HTMLButtonElement>) => {
    event.preventDefault();

    const {
      email,
      tel: phone,
      agree,
      agreeDailyMail,
      country,
      profile,
    } = this.props;

    const phoneCode = this.state.country && this.state.country.phoneCode;
    const tel = phoneCode ? ripOffLeadingZero(phoneCode, phone) : phone;

    const telValidation = validators.tel(tel);

    let submitTimeError;
    if (profile.sub0 === "ml_01en_2") {
      submitTimeError =
        validators.agree(agree) ||
        validators.emptyFields(email, country) ||
        (!profile.email && validators.emailFull(email)) ||
        (!profile.currency && validators.country(country));
    } else {
      submitTimeError =
        validators.agree(agree) ||
        validators.emptyFields(email, country, tel) ||
        (!profile.email && validators.emailFull(email)) ||
        (!profile.currency && validators.country(country)) ||
        (!profile.phone && telValidation);
    }

    let errors = {};
    errors.emailError = !profile.email && validators.emailFull(email);
    errors.countryError = !profile.currency && validators.country(country);
    errors.telError =
      profile.sub0 === "ml_01en_2" ? null : !profile.phone && telValidation;
    errors.agreeError = validators.agree(agree);

    if (submitTimeError) {
      if (profile.sub0 !== "ml_01en_2" && telValidation) {
        if (typeof this.props.logPhoneErrors === "function") {
          this.props.logPhoneErrors({
            filtered_input: tel,
            user_input: phone,
            error_msg: "auth: Invalid phone number",
            source: "additional_info",
            phone_example:
              getPhoneExample(this.state.country, this.props.apiCountries) ||
              "",
          });
        }
      }
      this.setState(errors);
      return;
    }

    this.setState({ pending: "host" });

    const c = () => {
      let o = {};
      o.daily_mail = agreeDailyMail ? 1 : 0;

      if (!profile.email) {
        o.email = email;
      }
      if (!profile.currency) {
        o.currency = country.currency;
      }
      if (profile.sub0 !== "ml_01en_2" && !profile.phone) {
        o.phone = tel;
      }
      o.sub0 = getSub0(window.location, this.props.serverData);
      return o;
    };
    const credentials = querystring.stringify(c());

    gaReducer("CLICKBTN_SOCIALREGISTER_MAINPAGE", { userId: profile.id });

    try {
      const response = await this.props.fetch(
        `/profile-update?${credentials}`,
        {
          unstable_dontInferResponse: true,
        }
      );

      this.setState({ pending: null });

      switch (response.status) {
        case "OK":
          this.props.dispatch({ type: "REQUEST_PROFILE" });
          this.props.setSocialError(null);
          if (typeof this.props.onDismissPopup === "function") {
            this.props.onDismissPopup();
          } else {
            this.props.history.push("/trade");
          }
          break;
        case "ERROR":
          this.props.setSocialError(response.message);
          this.setState({ responseTimeError: response.message });
          break;
        default:
          break;
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      [`${event.target.name}Error`]: null,
      submitTimeError: null,
      responseTimeError: null,
    });
    this.props.setSocialError(null);

    this.props.onInputChange(event);
  };

  handlePhoneInputChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      telError: null,
      submitTimeError: null,
      responseTimeError: null,
    });
    this.props.setSocialError(null);

    this.props.onPhoneInputChange(event);
  };

  showInfo = () => this.setState({ showPhoneInfo: true });

  hideInfo = () => this.setState({ showPhoneInfo: false });

  render() {
    const {
      agree,
      agreeDailyMail,
      tel,
      email,
      country,
      countryList,
      profile,
      isAppLogin,
    } = this.props;
    const {
      pending,
      emailError,
      countryError,
      telError,
      agreeError,
      submitTimeError,
      responseTimeError,
    } = this.state;

    const inputTimeError = validators.email(email);
    const errorMessage = responseTimeError || submitTimeError || inputTimeError;

    return (
      <div>
        <RegisterContainer>
          <FormText>
            <Gettext>Some required fields are missing!</Gettext>
          </FormText>

          <form method="post" id="socialForm">
            {this.state.fields.includes("email") && (
              <Input
                type="email"
                name="email"
                id="register-email"
                required="required"
                placeholder={this.props.gettext`Email`}
                value={email}
                onChange={this.handleInputChange}
                autocomplete="email"
              />
            )}
            {emailError && <ErrorMessage message={emailError} />}

            {this.state.fields.includes("currency") && (
              <InputContainer>
                <CountrySelect
                  name="country"
                  value={country}
                  options={countryList}
                  onChange={this.handleInputChange}
                />
              </InputContainer>
            )}
            {countryError && <ErrorMessage message={countryError} />}

            {profile && profile.sub0 === "ml_01en_2"
              ? null
              : this.state.fields.includes("phone") &&
                (FeatureFlags.useCoolPhoneInputOnAuth ? (
                  <PhoneFieldContainer>
                    <PhoneContainer>
                      {this.state.showPhoneInfo && (
                        <PhoneInfo>
                          <IconContainer>
                            <InfoIcon />
                          </IconContainer>
                          <InfoText>
                            <PhoneInputHint
                              countryCode={
                                this.state.country && this.state.country.code
                              }
                              phoneExample={getPhoneExample(
                                this.state.country,
                                this.props.apiCountries
                              )}
                            />
                          </InfoText>
                          <CloseInfo onClick={this.hideInfo}>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="4454.792 3403.601 10.606 10.607"
                            >
                              <g transform="translate(3350 3251)">
                                <rect
                                  width="1"
                                  height="14"
                                  fill="#b5b5b5"
                                  transform="translate(1114.691 152.601) rotate(45)"
                                />
                                <rect
                                  width="1"
                                  height="14"
                                  fill="#b5b5b5"
                                  transform="translate(1115.398 162.5) rotate(135)"
                                />
                              </g>
                            </svg>
                          </CloseInfo>
                        </PhoneInfo>
                      )}
                      <PhoneInput
                        SelectContainer={PhoneInputContainer}
                        InputContainer={PhoneInputContainer}
                        defaultCountry={this.props.geo}
                        value={tel}
                        onChange={({ fullNumber: phone, country }) => {
                          this.setState({ country });
                          this.handleInputChange({
                            target: {
                              name: "tel",
                              value: phone,
                            },
                          });
                        }}
                        // errorMessage={errorMessage}
                        placeholder={this.props.gettext`Phone`}
                        showInfo={<PhoneInputHint />}
                        onFocus={this.showInfo}
                        onBlur={this.hideInfo}
                      />
                    </PhoneContainer>
                  </PhoneFieldContainer>
                ) : (
                  this.state.fields.includes("phone") && (
                    <Input
                      type="tel"
                      name="tel"
                      id="register-phone"
                      required="required"
                      placeholder={this.props.gettext`Phone`}
                      value={tel}
                      onChange={this.handlePhoneInputChange}
                      autocomplete="tel"
                    />
                  )
                ))}
            {profile && profile.sub0 !== "ml_01en_2" && telError && (
              <ErrorMessage message={telError} />
            )}
            <CheckContainer>
              <Checkbox
                id="agreeChk"
                type="checkbox"
                checked={agree}
                name="agree"
                onChange={this.handleInputChange}
              />
              <CheckboxLabel checked={agree} htmlFor="agreeChk">
                {process.env.REACT_APP_DEPLOY_TARGET === "eztrader" ? (
                  <Gettext>I'm over 18 years old</Gettext>
                ) : (
                  <React.Fragment>
                    <Gettext>I'm over 18 years old and I agree with</Gettext>{" "}
                    <TermsLink
                      to="/conditions"
                      target="_blank"
                      title={this.props.gettext`Terms and Conditions`}
                    >
                      <Gettext>Terms and Conditions</Gettext>
                    </TermsLink>{" "}
                    <Gettext>and</Gettext>{" "}
                    <TermsLink
                      to="/return-refund-policy"
                      target="_blank"
                      title={this.props.gettext`Return and Refund Policy`}
                    >
                      <Gettext>Return and Refund Policy</Gettext>
                    </TermsLink>{" "}
                    <Gettext>and</Gettext>{" "}
                    <TermsLink
                      to="/privacy-policy"
                      target="_blank"
                      title={this.props.gettext`Privacy Policy`}
                    >
                      <Gettext>Privacy Policy</Gettext>
                    </TermsLink>
                  </React.Fragment>
                )}
              </CheckboxLabel>
            </CheckContainer>
            {agreeError && <ErrorMessage message={agreeError} />}

            <CheckContainer style={{ margin: "8px 0" }}>
              <Checkbox
                id="agreeDailyChk"
                type="checkbox"
                checked={agreeDailyMail}
                name="agreeDailyMail"
                onChange={this.handleInputChange}
              />
              <CheckboxLabel checked={agreeDailyMail} htmlFor="agreeDailyChk">
                <Gettext>
                  Subscribe me to special offers and tutorial content
                </Gettext>
              </CheckboxLabel>
            </CheckContainer>

            {errorMessage && <ErrorMessage message={errorMessage} />}

            <SubmitContainer>
              <BtnFormSubmit
                id="socialRegister"
                onClick={this.register}
                loader={pending === "host"}
                isIntlProject={
                  process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
                }
              >
                <Gettext>Register</Gettext>
              </BtnFormSubmit>
              {!isAppLogin && (
                <LogoutLink replace to="/logout">
                  <Gettext>Log out</Gettext>
                </LogoutLink>
              )}
            </SubmitContainer>
          </form>
        </RegisterContainer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...mapStateToGettext(state),
    serverData: state.serverData,
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToFetch
  )(SocialRegister)
);



// WEBPACK FOOTER //
// ./src/components/Auth/Tabs/SocialRegister.js